import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "./channels"
import "./sidebar"
import "./details_dropdown"
import "./combobox"
import "./nested_form"
import "./registration_form"
import "./course_form"
import "./student_form"
import "./copy_clipboard"

Rails.start()
ActiveStorage.start()
